<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="company-admin-user-modal-select" :title="title" bodyClass="container-md vstack gap-5">
		<template #body>
			<ul class="list-group list-group-flush rounded-4">
				<template v-if="users.length > 0">
					<li class="list-group-item px-0 py-3 lh-sm hstack gap-1" v-for="user in users" :key="user.id">
						<div class="vstack">
							<UserCardMedium :user="user" />
						</div>
						<div>
							<a href="javascript:void(0)" class="link-primary stretched-link" @click="select(user);">
								<i class="bi bi-check-circle text-xl text-success" v-if="selecteds.includes(user.id)"></i>
								<i class="bi bi-check text-xl" v-else></i>
							</a>
						</div>
					</li>
				</template>
				<template v-else>
					<li class="list-group-item px-0 py-3 lh-sm">
						No se encontraron registros.
					</li>
				</template>
			</ul>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, onBeforeMount } from 'vue';
	import composableForm from '@/composables/form';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';

	export default {
		emits: ['select'],
		props: {
			title: {
				type: String,
				default: 'Seleccionar usuarios'
			},
			filters: Object,
			selecteds: Array
		},
		setup(props, { emit }) {
			const { catchError } = composableForm();
			const offcanvas = ref(null);
			const users = ref([]);

			const show = () => {
				offcanvas.value.offcanvas.show();
			}

			const select = (user) => {
				emit('select', user);
			}

			onBeforeMount(async () => {
				await CompanyAdminUserRepository.list(props.filters).then((response) => {
					users.value = response.data;
				}).catch((e) => catchError(e, true));
			});

			return { offcanvas, users, show, select };
		}
	}
</script>